import Vue from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAngleDown,
  faAngleRight,
  faBars,
  faFileAlt,
  faThLarge,
  faFile,
  faUser,
  faLock,
  faAngleUp,
  faCalendarAlt,
  faPlusSquare,
  faPlusCircle,
  faTasks,
  faSearch,
  faCogs,
  faPaperclip,
  faSignOutAlt,
  faEye,
  faUserClock,
  faPlus,
  faTrashAlt,
  faExclamationTriangle,
  faHistory,
  faEllipsisV,
  faEdit,
  faClock,
  faBell,
  faDownload,
  faUpload,
  faSync,
  faTimesCircle,
  faHome,
  faUserCog,
  faShareSquare,
  faCheck,
  faCheckCircle,
  faRedo,
  faEnvelope,
  faMobileAlt,
  // OFF 2FA per-user (Approach A - 2026-08-11): icon nút tắt/bật lại 2FA cho user cụ thể.
  faUserSlash,
  faUserCheck,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faThLarge,
  faAngleDown,
  faAngleRight,
  faBars,
  faFileAlt,
  faFile,
  faUser,
  faLock,
  faAngleUp,
  faCalendarAlt,
  faPlusSquare,
  faPlusCircle,
  faTasks,
  faSearch,
  faCogs,
  faPaperclip,
  faSignOutAlt,
  faEye,
  faUserClock,
  faPlus,
  faTrashAlt,
  faExclamationTriangle,
  faHistory,
  faEllipsisV,
  faEdit,
  faClock,
  faBell,
  faDownload,
  faUpload,
  faSync,
  faTimesCircle,
  faHome,
  faUserCog,
  faShareSquare,
  faCheck,
  faCheckCircle,
  faRedo,
  faEnvelope,
  faMobileAlt,
  faUserSlash,
  faUserCheck,
);
Vue.component("font-awesome-icon", FontAwesomeIcon);
